<template>
  <Modal class="modal-scroll" size="large" @modalClose="onClose">
    <div class="modal-header">
      <h4 v-html="generateModalTitle()" />
      <button
        type="button"
        @click.stop="onClose"
        class="btn btn-link btm-sm btn-close-container">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <form v-on:submit.prevent="onSubmit">
      <div class="modal-body">
        <div class="section">
          <div class="row" v-if="isCreateFromExistingProgram()">
            <div class="col-md-6">
              <ManageScheduleItemPrograms
                :scheduleItem.sync="newScheduleItem"
                :updateScheduleItemStateError.sync="updateScheduleItemStateError" />
            </div>
            <div class="col-md-6">
              <ManageScheduleItemEpisodes
                :scheduleItem.sync="newScheduleItem"
                :updateScheduleItemStateError.sync="updateScheduleItemStateError" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-8">
              <FormGroup :errorMessage="updateScheduleItemStateError.programTitle">
                <h5 class="name">ชื่อ</h5>
                <input
                  type="text"
                  placeholder="ชื่อ"
                  class="form-control"
                  :class="{'is-invalid': updateScheduleItemStateError.programTitle }"
                  v-model="newScheduleItem.programTitle"
                  @blur="checkRequired($event, 'programTitle', 'ระบุชื่อ')" />
                <div
                  class="invalid-feedback"
                  v-if="updateScheduleItemStateError.programTitle">
                  ระบุชื่อ
                </div>
              </FormGroup>
              <FormGroup :errorMessage="updateScheduleItemStateError.episodeTitle">
                <h5 class="name">ชื่อตอน</h5>
                <input
                  type="text"
                  placeholder="ชื่อตอน"
                  class="form-control"
                  :class="{'is-invalid': updateScheduleItemStateError.episodeTitle }"
                  v-model="newScheduleItem.episodeTitle" />
                <div
                  class="invalid-feedback"
                  v-if="updateScheduleItemStateError.episodeTitle">
                  ระบุชื่อตอน
                </div>
              </FormGroup>
              <FormGroup>
                <h5 class="name">รายละเอียดอย่างสั้น</h5>
                <textarea
                  type="text"
                  rows="3"
                  class="form-control"
                  placeholder="รายละเอียดอย่างสั้น"
                  v-model="newScheduleItem.taglineCustom" />
              </FormGroup>
              <ManageScheduleItemContentCategory
                :scheduleItem.sync="newScheduleItem"
                :updateScheduleItemStateError.sync="updateScheduleItemStateError" />
              <!-- คุณสมบัติของรายการ -->
              <div class="form-group-container">
                <div class="form-group-item">
                  <ManageProgramFeatures
                    :features.sync="newScheduleItem.features"
                    :updateFeatureStateError.sync="updateScheduleItemStateError.features" />
                </div>
                <!-- คุณสมบัติของรายการ -->
                <div class="form-group-item">
                  <ManageProgramBroadcasting
                    :broadcastingChannels.sync="newScheduleItem.broadcastingChannels"
                    :updateBroadcastingStateError.sync="updateScheduleItemStateError.broadcastingChannels" />
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <ImageField
                :image.sync="newScheduleItem.coverImageCustom"
                :defaultImage="newScheduleItem.coverImage" />
            </div>
          </div>
        </div>
        <div class="section section-on-air">
          <FormGroup>
            <div class="form-check">
              <input type="checkbox"
                class="form-check-input"
                v-model="newScheduleItem.isRerun">
              <label class="form-check-label">
                เป็นรายการฉายซ้ำ
              </label>
            </div>
          </FormGroup>
          <!-- startTime / endTime -->
          <ManageScheduleItemTime
            :scheduleItem.sync="newScheduleItem"
            :updateScheduleItemStateError.sync="updateScheduleItemStateError" />
        </div>
      </div>
      <div class="modal-footer">
        <button type="button"
          class="btn btn-link pl-0"
          @click.stop="onClose">
          ยกเลิก
        </button>
        <button type="submit"
          class="btn btn-primary"
          :disabled="!isValid">
          {{getButtonLabel()}}
        </button>
      </div>
    </form>
  </Modal>
</template>

<script>
import _ from 'lodash';
import dateFormetter from '@/utils/dateFormatter';
import scheduleManagement from '@/utils/scheduleManagement';
import Modal from '@/components/Modal.vue';
import FormGroup from '@/components/FormGroup.vue';
import ImageField from '@/image/ImageField.vue';
import ManageProgramFeatures from '@/program/ManageProgramFeatures.vue';
import ManageProgramBroadcasting from '@/program/ManageProgramBroadcasting.vue';

import ManageScheduleItemTime from './scheduleItem/ManageScheduleItemTime.vue';
import ManageScheduleItemPrograms from './scheduleItem/ManageScheduleItemPrograms.vue';
import ManageScheduleItemEpisodes from './scheduleItem/ManageScheduleItemEpisodes.vue';
import ManageScheduleItemContentCategory from './scheduleItem/ManageScheduleItemContentCategory.vue';

export default {
  mixins: [dateFormetter, scheduleManagement],
  props: {
    scheduleItem: {
      type: Object,
      default: () => {},
    },
    scheduleDate: {
      type: String,
    },
    createScheduleType: {
      type: String,
      default: 'newSchedule', // existingProgram
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    onUpdated: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    Modal,
    FormGroup,
    ImageField,
    ManageProgramFeatures,
    ManageProgramBroadcasting,
    ManageScheduleItemTime,
    ManageScheduleItemPrograms,
    ManageScheduleItemEpisodes,
    ManageScheduleItemContentCategory,
  },
  data() {
    return {
      newScheduleItem: null,
      updateScheduleItemStateError: {
        programTitle: null,
      },
    };
  },
  created() {
    this.newScheduleItem = _.cloneDeep(this.defaultScheduleItem(this.scheduleDate));
    this.newScheduleItem = _.defaultsDeep(_.cloneDeep(this.scheduleItem), this.newScheduleItem);
  },
  computed: {
    isValid() {
      return this.newScheduleItem.programTitle;
    },
  },
  methods: {
    onSubmit() {
      // map start time / end time
      const scheduleTime = this.mappingScheduleTime(this.scheduleDate,
        this.newScheduleItem.startTime,
        this.newScheduleItem.endTime);

      const newScheduleItem = { ...this.newScheduleItem, ...scheduleTime };
      this.onUpdated(newScheduleItem);
    },
    isCreateFromExistingProgram() {
      return this.createScheduleType === 'existingProgram' || this.scheduleItem.programId;
    },
    checkRequired(event, fieldName, errorMessage) {
      if (!event.target.value) {
        this.updateScheduleItemStateError = _.set(this.updateScheduleItemStateError, fieldName, errorMessage);
      } else {
        this.updateScheduleItemStateError = _.set(this.updateScheduleItemStateError, fieldName, null);
      }
    },
    getButtonLabel() {
      if (!_.isEmpty(this.scheduleItem)) {
        return 'ปิด';
      }
      return 'สร้าง';
    },
    generateModalTitle() {
      if (!_.isEmpty(this.scheduleItem)) {
        return `แก้ไขรายการ <strong>${this.scheduleItem.programTitle}</strong>`;
      }
      return 'สร้างรายการใหม่บนผัง';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/helpers.scss';

.modal-scroll {
  align-items: flex-start;
  padding: $spacer * 1.5 0;
}

textarea {
  resize: none;
}

.modal-body {
  padding: 0;
  .section {
    padding: $spacer;
  }

  .section-on-air {
    border-top: 1px solid $gray-200;
  }
}


.form-group-container {
  display: flex;

  .form-group-item {
    margin-right: $spacer * 2;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
